import styled from 'styled-components'

export const Container = styled.div`
  padding: 20px;
  .top {
    margin-bottom: 20px;
  }
  .table {
    margin-top: 20px;
  }

  .demo-summary {
    margin-bottom: 16px;
  }

  .demo-video {
    display: block;
    width: 100%;
    max-height: 52vh;
    margin-top: 12px;
    background: #000;
    border-radius: 8px;
  }

  .demo-video-link {
    display: inline-block;
    margin-top: 12px;
  }
`
